export class SetSidebarWidth {
  public static readonly type = '[Sidebar Preferences] Set Width';
  constructor(public readonly widthRem: number) {}
}

export class SetSidebarPinned {
  public static readonly type = '[Sidebar Preferences] Set Pinned';
  constructor(public readonly isPinned: boolean) {}
}
